"use strict";
exports.__esModule = true;
exports.primitiveValue = exports.genericStatusMessage = void 0;
var t = require("io-ts");
/**
 * Basic shared schemas for usage as values in other schemas.
 */
exports.genericStatusMessage = t.type({ success: t.boolean });
exports.primitiveValue = t.union([t.boolean, t.number, t.string, t["null"]]);
//# sourceMappingURL=basic.js.map